import { LoginTranslate } from './loginTranslate.model';

const loginTranslateEN: LoginTranslate = {
  signIn: 'Sign In',
  signUp: {
    title: 'Create account',
    callToAction: "Don't have an account?",
    linkLabel: 'Sign up',
    haveAccount: 'Already have an account?',
    backToLogin: 'Back to login',
    submit: 'Create account',
    fields: {
      name: 'Full name',
      passwordConfirmation: 'Confirm password',
    },
    errors: {
      name: {
        required: 'Name is required',
        invalid: 'Name must contain only letters',
      },
      passwordConfirmation: {
        required: 'Password confirmation is required',
        mismatch: 'Passwords do not match',
      },
      submit: 'Could not create account. Please try again',
    },
  },
  fields: {
    email: 'E-mail',
    password: 'Password',
    code: 'Code',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
  },
  passwordVisibility: {
    show: 'Show password',
    hide: 'Hide password',
    showConfirmation: 'Show password confirmation',
    hideConfirmation: 'Hide password confirmation',
  },
  errors: {
    email: {
      required: 'E-mail is required',
      invalid: 'Invalid e-mail format',
    },
    password: {
      required: 'Password is required',
      invalid: 'Password must contain at least 8 characters',
    },
    code: {
      required: 'Code is required',
      invalid: 'Code must have 6 digits',
    },
    newPassword: {
      required: 'New password is required',
      minLength: 'Password must be at least 8 characters long',
    },
    confirmPassword: {
      required: 'Password confirmation is required',
      mismatch: 'Passwords do not match',
    },
    authenticate: 'Invalid e-mail or password',
  },
  passwordConfirmation: {
    title: 'Insert the code received via e-mail',
    text: 'As an additional security measure, please enter the six-digit code we sent to',
    success: 'Email confirmed. Sign in to continue.',
    buttons: {
      resend: 'Resend code',
      confirm: 'Confirm',
      back: 'Back',
    },
  },
  forgotPassword: {
    linkLabel: 'Forgot my password',
    title: 'Forgot my password',
    subtitle: 'Enter your email and we will send a code to reset your password',
    submit: 'Send code',
    success: 'Code sent to your email',
    backToLogin: 'Back to login',
  },
  confirmForgotPassword: {
    title: 'Reset password',
    subtitle: 'Enter the code received via email and your new password',
    submit: 'Reset password',
    backToLogin: 'Back to login',
    success: 'Password reset successfully',
    notReceivedHint:
      "Didn't receive the code? Your account may not be confirmed yet.",
    confirmAccountLink: 'Confirm my account',
  },
};

export default loginTranslateEN;
